import { render, staticRenderFns } from "./link-btn.vue?vue&type=template&id=37c61c25"
import script from "./link-btn.vue?vue&type=script&lang=js"
export * from "./link-btn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports